import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=b77cdc52&scoped=true&"
import script from "./Privacy.vue?vue&type=script&lang=js&"
export * from "./Privacy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Privacy.vue?vue&type=style&index=1&id=b77cdc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77cdc52",
  null
  
)

export default component.exports